import React, { useEffect, useState } from "react";
import LoadingSpinner from "../components/common/LoadingSpinner";
import { httpReauest } from "../utils/httpRequest";
import { Link, useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaShoppingCart,
  FaUtensils,
  FaHome,
  FaGamepad,
  FaUser,
} from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";
import Layout from "../components/layout";
import AddressModal from "../components/common/modal/AddressModal";
import { ArrowDown2 } from "iconsax-reactjs";
import OrderCard from "../components/common/card/OrderCard";
import { useTranslation } from "react-i18next";
import LangugeChanger from "../components/common/LangugeChanger";
import TodayMenu from "../components/layout/TodayMenu";
import { useCart } from "../context/CartContext";

const Home = () => {
  const [firstOrder, setfirstOrder] = useState(false);
  const [addressModal, setaddressModal] = useState();
  const [orders, setorders] = useState([]);
  const [data, setdata] = useState();
  const { cartItems, addToCart, updateQuantity } = useCart();

  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.body.dir = i18n.language === "ar" ? "rtl" : "ltr";
  }, [i18n.language]);

  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    const user = JSON.parse(localStorage.getItem("user"));

    // اگر لاگین نیست، فقط هیچی نکن؛ بذار صفحه با منو و TodayMenu لود بشه
    if (!user) {
      return;
    }

    try {
      const res = await httpReauest(
        "GET",
        "/user/info/" + user?._id,
        {},
        { "x-access-token": user?.token }
      );

      setdata(res.data.data?.user);
      setorders(res.data.data?.orders);
      setfirstOrder(res.data.data?.firstOrder);
    } catch (err) {
      // توکن خراب/منقضی شده
      localStorage.removeItem("user");
      navigate("/login");
    }
  }

  return (
    <div className="min-h-screen  flex flex-col justify-between text-[var(--primary)]">
      <AddressModal
        show={addressModal}
        setShow={setaddressModal}
        getData={getData}
        selectedAddress={data?.selectedAddress?._id}
      />
      <Layout>
        <div className="flex items-center justify-between px-4 py-3 bg-yellow-200 shadow relative">
          {/* Language Dropdown */}
          <LangugeChanger />

          {/* Address Selector */}
          <button
            onClick={() => setaddressModal(true)}
            className="flex items-center space-x-1 text-sm font-semibold text-green-800 cursor-pointer"
          >
            <MdLocationOn className="text-lg" />
            <span>
              {data?.selectedAddress
                ? data?.selectedAddress?.name
                : "Select An Address"}
            </span>
            <ArrowDown2 size={16} />
          </button>

          {/* Cart Icon */}
          <Link to={"/cart"} className="text-xl relative">
            <FaShoppingCart />
            <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs px-1 rounded-full">
              {cartItems?.length}
            </span>
          </Link>
        </div>

        <div className="text-center py-4 bg-yellow-300 shadow-inner">
          <img
            src="/logo.png"
            className="w-[100px] mx-auto"
            alt="Sambite Logo"
          />
          <h1 className="text-2xl font-bold">🍔 {t("Sambite-restaurant")}</h1>
          <p className="text-sm text-green-800">{t("home-first-text")}</p>
        </div>

        {/* Main Content */}
        <div className="p-4 pb-28">
          <div className="mb-6 space-y-2">
            <button className="w-full bg-[var(--secondry)] text-white py-3 rounded-xl text-xl font-semibold flex items-center justify-center space-x-2 gap-2">
              <FaUtensils />
              <span>{t("order-food")}</span>
            </button>
            <Link
              to={"/game"}
              className="w-full bg-[var(--primary)] text-white py-3 rounded-xl text-xl font-semibold flex items-center justify-center space-x-2 gap-2"
            >
              <FaGamepad />
              <span>{t("start-game")}</span>
            </Link>
          </div>

          {orders?.length ? (
            <section className="mb-8">
              <h2 className="text-xl font-bold mb-4 text-center text-[var(--secondry)]">
                {t("orders-in-preparing")}
              </h2>
              <div className="grid">
                {orders.map((order) => (
                  <OrderCard order={order} />
                ))}
              </div>
            </section>
          ) : null}

          {firstOrder && (
            <div className="bg-green-100 border border-green-400 text-green-900 px-6 py-4 rounded-xl shadow-lg  mb-4 flex flex-col items-center text-center">
              <h3 className="text-xl font-bold mb-2">
                🎁 {t("free_delivery_title")}
              </h3>
              <p className="text-sm mb-4">{t("free_delivery_description")}</p>
              <button
                onClick={() => navigate("/restaurant")}
                className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-lg text-sm font-semibold transition"
              >
                {t("order_now")}
              </button>
            </div>
          )}

          {/* Menu Section */}

          <TodayMenu />
        </div>
      </Layout>
    </div>
  );
};

export default Home;
